import { getDisplayDurationFromMs } from '@gonfalon/format/getDisplayDurationFromMs';
import { Cell, Column, Row, Table, TableBody, TableHeader } from '@launchpad-ui/components';

import type { Stage } from '../types';

import styles from '../tableContainer.module.css';

interface RolloutStagesTableProps {
  stages: Stage[];
}

export function RolloutStagesTable({ stages }: RolloutStagesTableProps) {
  return (
    <div className={styles.tableContainer} data-test-id="stages-table">
      <Table aria-label="Rollout steps">
        <TableHeader>
          <Column isRowHeader>Step</Column>
          <Column>Weight</Column>
          <Column>Duration</Column>
        </TableHeader>
        <TableBody items={stages.map((stage, index) => ({ ...stage, stageNumber: index + 1 }))}>
          {(stage) => (
            <Row id={stage.stageNumber}>
              <Cell>{stage.stageNumber}</Cell>
              <Cell>{stage.rolloutWeight / 1000}%</Cell>
              <Cell>
                {stage.monitoringWindowMilliseconds !== undefined
                  ? getDisplayDurationFromMs(stage.monitoringWindowMilliseconds, { format: 'short' })
                  : ''}
              </Cell>
            </Row>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
